// used in profile-edit.component.ts

import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable()
export class UpdateFidoProfileHelper {
    private profileInfo = new Subject<any>();

    sendUpdate(updatedFidoPayload: object) {
        this.profileInfo.next({ data: updatedFidoPayload });
    }

    getUpdate(): Observable<any> {
        return this.profileInfo.asObservable();
    }

    convertRole(passportRole: number): string {
        return passportRole === 5
                ? "student"
                : passportRole === 4
                ? "instructor"
                : passportRole === 1
                ? "distributor"
                : "other";
    }
}
